export const allFunctions = 'All functions';
export const allDepartments = 'All departments';
